import { useEffect, useState } from 'react';
import styles from './Datepicker.module.css';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import Calendar from 'images/calendar.svg';

/**
 * @param {string} date 선택한 날짜
 * @param {boolean} readOnly readOnly
 * @param {boolean} icon 캘린더 아이콘 표시 여부
 */
const Datepicker = ({date, setDate, readOnly=false, icon=true}) => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const today = new Date();

  useEffect(() => {
    setDate(selectedDate);
  }, [selectedDate]);
  
  return (
    <div className={styles['datepicker-wrap']}>
      {icon ? <div className={styles['img']}><img src={Calendar} alt="캘린더" /></div> : '' }
      <DatePicker
        todayButton={<div className={styles['today-btn']}><div>Today</div></div>}
        selected={selectedDate}
        dateFormat='yyyy-MM-dd'
        onChange={(date) => setSelectedDate(date)}
        readOnly={readOnly}
        maxDate={new Date()}
      />
    </div>
  );
}
export default Datepicker;